var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":_vm.SkipSwitchName}},[_c('router-view',{key:_vm.$route.fullPath})],1),(_vm.$store.state.isSim)?_c('div',{staticClass:"sim-tag"},[_vm._v(_vm._s(_vm.$t('trade').simulatedTrading))]):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }